const confirmationMessages = [
  'Bring on the matrimony!',
  'Hey, you. You\'re doing great.',
  'Time for a snack break.',
  'You\'ve got this.',
  'Victory is yours.',
  'Keep calm and plan on.',
  'What\'s it feel like to fly? Let us know.',
  'YAAAASSSSSS',
  'You\'re getting married! How cool is that?',
  'Oh yeaaaaaaa.',
  'Look at you plowing through.',
  'Oh, you\'re making magic happen? Cool. Carry on.',
  'You look really great today.',
  'Everything is figure-outable.',
  'Look at you, you\'re on a roll.',
  'You is kind. You is smart. You is important.',
  'This is going to be a great day.',
  'You\'re our favorite couple. Seriously.',
  'Woo hoo!',
  'This wedding is going to be epic.',
  'When in doubt: caffeinate.',
  'Your fiancé is the luckiest person on earth.',
  'You rock. Can we marry you?',
  'Can we bring a plus one to your wedding? KIDDING.',
  'You\'re inspiring us to get sh!t done.',
  'Yippee!',
  'You are crushing your wedding planning.',
  'You can do this. You. Can. Do. This. ',
  'You guys are really cute together.',
  'Getting married is just the beginning.',
  'Homestretch!',
  'Ready to boogie?',
  'Any more cake left?'
];

const getTaskCompletedMsg = () => {
  const randomNumber = Math.floor(Math.random() * confirmationMessages.length);
  return confirmationMessages[randomNumber];
};

export default getTaskCompletedMsg;



// WEBPACK FOOTER //
// ./src/util/getTaskCompletedMsg.js